// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__JlJhV","icons":"SearchBar_icons__tSJF6","searchbutton":"SearchBar_searchbutton__C3Vtu","inputSearch":"SearchBar_inputSearch__6CjJq"};